export interface GuestlistAccessFilterType {
  selectedLists: server.dto.GuestlistList[]
  initialLists: server.dto.GuestlistList[]
}

export const getSortedAccessTypes = (filter: GuestlistAccessFilterType) => {
  return [...filter.selectedLists].sort((a, b) => {
    const indexA = filter.initialLists.findIndex(value => value === a);
    const indexB = filter.initialLists.findIndex(value => value === b);
    return indexA - indexB;
  });
};

export const initialAccessFilter: GuestlistAccessFilterType = {
  selectedLists: [],
  initialLists: []
};